<div [@routeAnimations]="o && o.activatedRouteData 
&& o.activatedRouteData['animation']">
        <router-outlet #o="outlet"></router-outlet>
    </div>